import React from 'react';
import {Modal} from 'react-bootstrap';
import AbstractComponent from '../../AbstractComponent';
import Button from '../button/Button';
class ModalQuestion extends AbstractComponent {        
    fechar() {
        if(this.props.fechar() !== undefined) 
            this.props.fechar()
    }

    btnSimClick() {
        if(this.props.btnSimClick !== undefined) {
            this.props.btnSimClick();
        }
    }

    btnNaoClick() {                
        if(this.props.btnNaoClick !== undefined) {
            this.props.btnNaoClick();
        }
    }    

    texto() {        
        if(this.props.texto !== undefined)
            return this.props.texto;

        if(this.props.children !== undefined)
            return this.props.children;
    
        return ;
    }          

    styleHeader() {                
        return (this.props.styleHeader === undefined) ? "bg-white" : this.props.styleHeader;
    }

    styleIcon() {
        if(this.props.styleIcon === undefined)
            return ; 

        return (
            <i className={this.props.styleIcon}/> 
        );
    }

    styleText() {
        return (this.props.styleText === undefined) ? "text-dark" : this.props.styleText;        
    }

    styleButtonSim() {       
        return (this.props.styleButtonSim === undefined) ? "btn-primary" : this.props.styleButtonSim;                
    }

    styleButtonNao() {
        return (this.props.styleButtonNao === undefined) ? "btn-danger" : this.props.styleButtonNao;        
    }

    buttonSimTxt() {
        return (this.props.buttonSimTxt === undefined) ? 'Sim' : this.props.buttonSimTxt;
    }

    buttonNaoTxt() {
        return (this.props.buttonNaoTxt === undefined) ? 'Não' : this.props.buttonNaoTxt;
    }

    render() {
        return (
            <Modal show={this.props.show} 
                   className={this.props.className}
                   style={{zIndex: 9999}}
                   onHide={() => this.fechar()}>
                {
                    this.props.header !== "" &&
                    <Modal.Header className={this.styleHeader()}
                                  closeButton>
                        <h4>
                            { this.styleIcon() }
                            &nbsp;
                            {this.props.header}
                        </h4>
                    </Modal.Header>
                }                                

                <Modal.Body className={"text-center " + this.styleText()} 
                    style={{marginBottom: '15px'}}>
                    <div className={"text-center " + this.styleText()} 
                        style={{marginBottom: '15px'}}>
                        {this.texto()}
                    </div>                    
                                    

                    <div className="row" style={{marginTop: '30px'}}>
                        <div className="col-md-6 
                                        col-sm-6
                                        col-lg-6
                                        col-xs-6">
                            <Button                                    
                                className={"text-center btn " + this.styleButtonSim()}                                      
                                type="button" 
                                background={3}
                                color={false}
                                style={{
                                    width: 'auto',
                                    minWidth: '60px',
                                    height: '45px'
                                }}        
                                preload={this.props.preload}                        
                                onClick={() => {this.btnSimClick()}}
                            >
                                {this.buttonSimTxt()}
                            </Button>
                        </div>

                        <div className="col-md-6 
                                        col-sm-6
                                        col-lg-6
                                        col-xs-6">
                            <Button 
                                className={"text-center btn " + this.styleButtonNao()}  
                                type="button" 
                                style={{
                                    width: 'auto',
                                    minWidth: '60px',
                                    height: '45px'
                                }}
                                background={3}                                    
                                onClick={() => {this.btnNaoClick()}}
                            >
                                {this.buttonNaoTxt()}
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}

export default ModalQuestion;